import React from 'react';

import img1Timer from '../../assets/images/fighters-image/timer-img1.png';
import img2Timer from '../../assets/images/fighters-image/timer-img2.png';
import img3Timer from '../../assets/images/fighters-image/timer-img3.png';
import img4Timer from '../../assets/images/fighters-image/timer-img4.png';
import img5Timer from '../../assets/images/fighters-image/timer-img5.png';

export const Timer = ({ time }) => {
  return (
    <div className='f-game-timer'>
      <div className='f-game-timer-inner rotate-timer'>
        {/* add/remove rotate-timer */}
        <div className='loading-layer big'>
          <img src={img1Timer} alt='' />
        </div>
        <div className='loading-layer middle'>
          <img src={img2Timer} alt='' />
        </div>
        <div className='loading-layer small'>
          <img src={img3Timer} alt='' />
        </div>
        <div className='loading-layer in'>
          <img src={img4Timer} alt='' />
        </div>
        <div className='loading-layer bg-circle'>
          <img src={img5Timer} alt='' />
        </div>
        <p className='game-timer-number'>{time}</p>
      </div>
    </div>
  );
};
